export default __webpack_public_path__ + "static/media/default.5779840bbdb93c9bcc99cd4b01a55c4a.png";